import styled from 'styled-components';
import { getSpace, getGridSpans } from '../../../stylesheets/tools';

const StyledNewsroomSection = styled.div`
  margin-bottom: ${getSpace('xxl')};

  .newsroomSection__headline {
    margin: ${getSpace('l')} 0;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .newsroomSection__link {
    ${getGridSpans('width', { s: 12, m: 10 })}
    ${getGridSpans('margin-left', { s: 0, m: [1, 'spread'] })}
    display: flex;
    align-items: center;
    justify-content: flex-end;
    text-transform: uppercase;

    svg {
      width: 25px;
      height: 12px;
      margin-left: ${getSpace('5px')};
    }
  }
`;

export default StyledNewsroomSection;
